import amapi from '@/api/amapi'

const initialState = () => ({
  products: [],
  renewalPricing: {},
})

const state = initialState

const getters = {
  products: state => state.products,
  renewalPricing: state => state.renewalPricing,
}

const mutations = {
  SET_PRODUCTS (state, products) {
    state.products = products
  },
  SET_RENEWAL_PRICING (state, { pricing }) {
    state.renewalPricing = pricing
  },
}

const actions = {
  async getProducts ({ commit, dispatch }) {
    try {
      const { products } = await amapi.makecall('orderapi/get_session')
      commit('SET_PRODUCTS', products)
    } catch (e) {
      dispatch('reportError', 'Can not get products', { root: true })
      throw e
    }
  },
  async renewEarly ({ dispatch, commit, rootGetters }, payload) {
    const data = {
      action: 'requestrenewal',
      ...payload,
    }
    let response = {}

    try {
      response = await amapi.makecall('hosting_renewearly', data)
      if (response.result === 'success') {
        await dispatch('getServices', { withDomains: true }, { root: true })

        const hosting = rootGetters.services.find(service => service.id === rootGetters.hosting.id)
        if (hosting) {
          commit('POPULATE_HOSTING', hosting, { root: true }) // repopulate hosting data
        }
      }
    } catch (e) {
      throw e
    }

    return response
  },
  async getRenewalPricing ({ commit }, payload) {
    const data = {
      service_id: payload.serviceId,
    }
    const response = await amapi.makecall('hosting_renewearly', data)

    commit('SET_RENEWAL_PRICING', { pricing: response.pricing || {} })
  },
}
const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
